import FadeIn from '@/components/shared/FadeIn';
import SectionBackdrop from './SectionBackdrop';

const VALUE_PROPS = [
  {
    label: 'Complete Coverage',
    heading: 'Underground to rooftop.\nNothing missed.',
    body: 'Underground documentation, drone capture for every deck, and 360-degree progress photos — every inch of your site, memorialized permanently.',
    image: '/static/images/drones_videos_10th_&_Cherokee_PT_Decks_4.26.25_a9a75abc-f655-4507-8c9e-40f407f38dc0_10th_PT50_4.26.25_media_zoomImage_BC7C77B5_808C_6A0A_41D6_FBC3FA5701EE_en_0_0.jpg',
  },
  {
    label: 'Reduce Liability',
    heading: 'Your best defense\nstarts at capture.',
    body: 'Accurate as-built records protect you in disputes. Eliminate costly litigation, validate in-place work, and simplify long-term operations and maintenance.',
    image: '/static/images/hallway_500.png',
  },
  {
    label: 'One Low Price',
    heading: 'Everything turnkey.\nNo surprises.',
    body: 'Drone, underground, and 360-degree documentation — delivered as a single flat-fee service. No hidden costs, no coordination overhead.',
    image: '/static/images/sf2_500.png',
  },
];

const ValuePropositionSection: React.FC = () => {
  return (
    <section id="value-proposition" className="relative overflow-hidden bg-maintenance-dark py-24 md:py-32">
      <SectionBackdrop variant="blue-cyan" glowPosition="top-right" pattern="isometric" />

      <div className="relative z-10 container mx-auto px-6 md:px-12 lg:px-16">
        {/* Section header */}
        <FadeIn className="mb-16 md:mb-20 max-w-2xl">
          <p className="text-maintenance-cyan text-xs uppercase tracking-widest font-semibold mb-4">Why Ironview 360</p>
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white leading-tight">
            Built for the way construction works.
          </h2>
        </FadeIn>

        {/* Feature rows — alternating emphasis */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          {VALUE_PROPS.map((prop, i) => (
            <FadeIn key={prop.label} delay={i * 120} className="group relative overflow-hidden rounded-2xl bg-white/[0.03] border border-white/8 hover:border-white/20 transition-colors">
              {/* Image */}
              <div className="h-56 overflow-hidden">
                <img
                  src={prop.image}
                  alt={prop.label}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-maintenance-dark to-transparent" style={{top: '140px', position: 'absolute'}} />
              </div>

              {/* Text */}
              <div className="p-6 md:p-8">
                <p className="text-white font-bold mb-3">{prop.label}</p>
                <h3 className="text-xl md:text-2xl font-bold text-white mb-3 leading-snug whitespace-pre-line">
                  {prop.heading}
                </h3>
                <p className="text-white/50 text-sm md:text-base leading-relaxed">{prop.body}</p>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuePropositionSection;
